export const ConfigMantenedorReseller = {
   barraBusqueda: {
      criterios: ["Rut", "Razón Social", "Nombre Contacto"],
      criteriosKeys: ["rut", "razonSocial", "nombreContacto"],
      criterioPrincipal: "Razón Social",
   },
};
